"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDashboardData = void 0;
const axios_1 = require("axios");
const react_query_1 = require("react-query");
const CredentialStore_1 = require("../../stores/CredentialStore");
const Utils_1 = require("../../utils/Utils");
exports.GetDashboardData = () => {
    const docId = CredentialStore_1.credentialStore((state) => state.docId);
    const jwt = CredentialStore_1.credentialStore((state) => state.token);
    return react_query_1.useQuery(`get Dashboard details ${docId}`, () => axios_1.default.get(`${Utils_1.APIURL}/api/fungus/get/dashboard`, {
        headers: {
            'auth-token': jwt,
        },
    }), {
        staleTime: 60000,
        refetchOnWindowFocus: false,
    });
};
//# sourceMappingURL=DashboardProvider.js.map